module.exports = __webpack_public_path__ + "static/media/icon-food.5f0e5b75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/RewardIcon/icon-food.svg
// module id = 1434
// module chunks = 1